<template>
  <!--公告通知-->
  <div class="table-class">
    <div style="margin-left:7%;width: 40.5%;">
      <el-table
        :data="tableData1"
        stripe
        style="width: 100%" class="t-table-class">
        <el-table-column
          prop="notice"
          label="通知公告"
          width="500">
          <template slot-scope="scope">
            <a href="scope.row.notice" target="_blank" class="buttonText">{{scope.row.notice}}</a>
          </template>
        </el-table-column>

        <el-table-column
          prop="date1"
          width="100">
          <template slot="header" slot-scope="scope">
            <a href="" target="_blank">More<<</a>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div style="margin-left: 2%; width:40.5%;">
      <el-table
        :data="tableData2"
        stripe
        style="width: 100%">
        <el-table-column
          prop="msg"
          label="活动通知"
          width="500">
          <template slot-scope="scope">
            <a href="scope.row.msg" target="_blank" class="buttonText">{{scope.row.msg}}</a>
          </template>
        </el-table-column>

        <el-table-column
          prop="date2"

          width="100">
          <template slot="header" slot-scope="scope">
            <a href="" target="_blank">More<<</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData1: [{
        notice: '端午活动！',
        date1 :'2020-3-6'
      }, {
        notice: '端午活动！',
        date1 :'2020-3-6'
      }, {
        notice: '端午活动！',
        date1 :'2020-3-6'
      },],
      tableData2: [{
        msg: '感冒胶囊买一赠二！',
        date2 :'2020-3-6'
      }, {
        msg: '厂家政策！',
        date2 :'2020-3-6'
      }, {
        msg: '阿莫西林满100减5！',
        date2 :'2020-3-6'
      }]

    }
  }
}
</script>

<style scoped>
a{
  color: #7ac804;
}
.t-table-class{
  margin-left: 5%;
}
.table-class{
  display: flex;
}
</style>




// WEBPACK FOOTER //
// src/components/component/Notice.vue